import {
    IntegratedCompliancePropertyStatus,
    IntegratedComplianceServiceStatus,
    IntegratedPortfolioFacets,
    ServicingStatuses,
    StateShortName,
} from '@acp/shared';
import {
    HStack,
    Popover, PopoverTrigger, Text,
} from '@chakra-ui/react';
import { FaIcon } from '@acp/core-ui';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { ComplianceInfoPopoverContent } from './compliance-info-popover-content';

export const managedByOptions = [
    {
        label: 'Detector Inspector',
        value: 'DETECTOR_INSPECTOR',
    },
    {
        label: 'Other',
        value: 'OTHER',
    },
];

export const facetCategories = [
    {
        label: 'Property compliance',
        description: '',
        value: 'PROPERTY_COMPLIANCE_STATUS',
        applicableStates: null,
    },
    {
        label: 'Servicing',
        description: '',
        value: 'SERVICING_STATUS',
        applicableStates: null,
    },
];

const propertyComplianceStatusOptions = [
    {
        label: (
            <HStack>
                <Text>Compliant*</Text>
                <Popover trigger="hover" isLazy placement="auto">
                    <PopoverTrigger>
                        <FaIcon icon={faInfoCircle} color="muted.300" size="sm" />
                    </PopoverTrigger>
                    <ComplianceInfoPopoverContent
                        complianceStatus={IntegratedCompliancePropertyStatus.Compliant}
                    />
                </Popover>
            </HStack>
        ),
        description: '',
        value: IntegratedPortfolioFacets.Compliant,
        category: 'PROPERTY_COMPLIANCE_STATUS',
        applicableStates: null,
    },
    {
        label: (
            <HStack>
                <Text>Compliance issues*</Text>
                <Popover trigger="hover" isLazy placement="auto">
                    <PopoverTrigger>
                        <FaIcon icon={faInfoCircle} color="muted.300" size="sm" />
                    </PopoverTrigger>
                    <ComplianceInfoPopoverContent
                        complianceStatus={IntegratedCompliancePropertyStatus.ComplianceIssues}

                    />
                </Popover>
            </HStack>
        ),
        description: '',
        value: IntegratedPortfolioFacets.NonCompliant,
        category: 'PROPERTY_COMPLIANCE_STATUS',
        applicableStates: null,
    },
];

const servicingStatusOptions = [
    {
        label: 'Approaching next service',
        description: 'Properties with at least one service due within the next 30 days',
        value: ServicingStatuses.ApproachingNextService,
        category: 'SERVICING_STATUS',
        applicableStates: null,
    },
    {
        label: 'Overdue',
        description: 'Properties with at least one service that has passed its due date',
        value: ServicingStatuses.Overdue,
        category: 'SERVICING_STATUS',
        applicableStates: null,
    },
];

export const facetOptions = [
    {
        label: 'Gas confirmation required',
        description: '',
        value: IntegratedComplianceServiceStatus.GasConfirmationRequired,
        applicableStates: [StateShortName.VIC],
    },
    {
        label: 'Missing service provider',
        description: '',
        value: IntegratedPortfolioFacets.MissingSupplier,
        applicableStates: null,
    },
    {
        label: 'Missing last service date',
        description: '',
        value: IntegratedPortfolioFacets.MissingLastServiceDate,
        applicableStates: null,
    },
    {
        label: 'Rectification required',
        description: '',
        value: IntegratedPortfolioFacets.FurtherWorksRequired,
        applicableStates: null,
    },
    {
        label: 'Recently added',
        description: 'New properties added in the last 30 days',
        value: IntegratedPortfolioFacets.RecentlyAdded,
        applicableStates: null,
    },
    {
        label: 'Under enrolment',
        description: 'An enrolment has been started',
        value: IntegratedPortfolioFacets.UnderEnrolment,
        applicableStates: null,
    },
    ...propertyComplianceStatusOptions,
    ...servicingStatusOptions,
    {
        label: 'Non-residential property',
        description: '',
        value: IntegratedPortfolioFacets.NonResidentialProperty,
        applicableStates: null,
    },
];
